import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import InicioPage from "../Pages/Inicio/Inicio";
import Layout from "../Pages/Layout";
import Login from "../Components/ui/Login";
import "./app.scss";

import { AuthProvider } from "../Components/hooks/UseAuth";
import PrivateRoute from "./PrivateRoute";
import PerfilesListPage from "../Pages/Perfiles/PerfilesList";

import PerfilesDetailPage from "../Pages/Perfiles/PerfilesDetail";
import UsuariosDetailPage from "../Pages/Usuarios/UserDetails";

import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";
import PlantillaPage from "../Pages/Plantillas/PlantillaList";
import PlantillaDetailPage from "../Pages/Plantillas/PlantillaDetails";
import UsuariosListPage from "../Pages/Usuarios/UsersList";
import DiccionarioPage from "../Pages/Diccionario/DiccionarioList";
import DiccionarioDetailPage from "../Pages/Diccionario/DiccionarioDetails";
import { ContextProvider } from "../store/masterDoc-context";

function App() {


  const [state, setState] = useState({
    codMaster: "",
  });

  return (
    <ConfigProvider locale={esES}>
      <AuthProvider>
        <ContextProvider value={[state, setState]}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<PrivateRoute />}>
                <Route path="/" element={<Layout />}>
                  <Route path="/" exact element={<InicioPage />} />
                  <Route path="/Perfiles" element={<PerfilesListPage />} />
                  <Route path="/Perfiles/:id" element={<PerfilesDetailPage />}
                  />
                  <Route path="/Usuarios" element={<UsuariosListPage />} />
                  <Route path="/Usuarios/:id" element={<UsuariosDetailPage />}
                  />
                  <Route path="/Plantillas" element={<PlantillaPage />} />
                  <Route path="/Plantillas/:id" element={<PlantillaDetailPage />}
                  />
                  <Route path="/Diccionario" element={<DiccionarioPage />} />
                  <Route path="/Diccionario/:id" element={<DiccionarioDetailPage />} />

                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
        </ContextProvider>
      </AuthProvider>
    </ConfigProvider>

  );
}
export default App;
